module.exports = __webpack_public_path__ + "static/media/einstein-header-icon.f8631ce6.svg";